module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "bulk-confirm-result-dialog",
    attrs: {
      "title": "Bulk Confirm Results",
      "width": "80%",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "result-summary"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.summaryTitle,
      "type": _vm.summaryType,
      "closable": false,
      "show-icon": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_c('strong', [_vm._v("Total Packages:")]), _vm._v(" " + _vm._s(_vm.result.totalPackages))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Successful:")]), _vm._v(" " + _vm._s(_vm.result.successCount))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Failed:")]), _vm._v(" " + _vm._s(_vm.result.failedCount))]), _vm._v(" "), (_vm.result.batchNumber) ? _c('p', [_c('strong', [_vm._v("Batch Number:")]), _vm._v(" " + _vm._s(_vm.result.batchNumber))]) : _vm._e()])])], 1), _vm._v(" "), (_vm.result.successCount > 0) ? _c('div', {
    staticClass: "success-section"
  }, [_c('h3', {
    staticClass: "section-title success-title"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v("\n      Successfully Created Packages: " + _vm._s(_vm.result.successCount) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('div', {
    staticClass: "failure-section"
  }, [_c('div', {
    staticClass: "failure-header"
  }, [_c('h3', {
    staticClass: "section-title error-title"
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  }), _vm._v("\n        Failed Packages (" + _vm._s(_vm.result.failedCount) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "failure-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": _vm.copyFailedData
    }
  }, [_vm._v("\n          Copy to Clipboard\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.exportFailedData
    }
  }, [_vm._v("\n          Export to CSV\n        ")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.result.failureRecords,
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('code', {
          staticClass: "tracking-code"
        }, [_vm._v(_vm._s(scope.row.tracking))])]
      }
    }], null, false, 1666644289)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemCount",
      "label": "UPC Items",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v(_vm._s(scope.row.itemCount || 0))])]
      }
    }], null, false, 4265133008)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errorMessage",
      "label": "Error Reason",
      "min-width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "error-message-cell"
        }, [_c('el-tooltip', {
          attrs: {
            "content": scope.row.errorMessage,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "error-text"
        }, [_vm._v(_vm._s(scope.row.errorMessage))])]), _vm._v(" "), _c('el-tag', {
          staticClass: "retry-tag",
          attrs: {
            "type": scope.row.canRetry ? 'warning' : 'danger',
            "size": "mini"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.canRetry ? 'Can Retry' : 'Cannot Retry') + "\n            ")])], 1)]
      }
    }], null, false, 3170467878)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('div', {
    staticClass: "failure-statistics"
  }, [_c('h4', [_vm._v("Failure Analysis")]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Duplicate Tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "stat-value duplicate"
  }, [_vm._v(_vm._s(_vm.duplicateCount))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Retryable Errors:")]), _vm._v(" "), _c('span', {
    staticClass: "stat-value retryable"
  }, [_vm._v(_vm._s(_vm.retryableCount))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Non-retryable Errors:")]), _vm._v(" "), _c('span', {
    staticClass: "stat-value non-retryable"
  }, [_vm._v(_vm._s(_vm.nonRetryableCount))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [(_vm.hasRetryableFailures) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.retrying
    },
    on: {
      "click": _vm.retryFailures
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v("\n        Retry Failed Packages (" + _vm._s(_vm.retryableCount) + ")\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.result.successCount > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.continueOperation
    }
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("\n        Continue\n      ")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49118cb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BulkConfirmResultDialog.vue
// module id = 824
// module chunks = 1